<template>
    <el-aside class='aside'>
        <div class="logo">
            <img :src="config.logo_02">
            <span>{{config.logoName}}</span>
        </div>
        <div>
            <el-menu class="menu" :collapse='true' :collapse-transition='false'>
                <el-submenu @click.native='chooseMenu(item, index)' v-for='(item,index) in menuList' :key='index' :popper-class='String(index)' :class="['menu_item',TABACTIVE.root==item.code?'menu_active':'']" :index='String(index)'>
                    <template slot="title">
                        <!-- <i :class="['iconfont','icon-' + item.code]"></i> -->
                        <!-- <img class='menu-icon' :src='imgPrefix_qN + imgPrefix_qN' /> -->
                        <i class="icon-wrap">
                            <!-- <i class="icon-item" :style="styleObject"></i> -->
                            <i class="icon-item" :style="{ background:  'url('+ imgPrefix_qN + item.icon+')'+ 'no-repeat center' }"></i>
                        </i>
                        {{item.name}}
                    </template>
                    <el-menu-item-group v-for='(jtem,jndex) in item.childList' :key='jndex' :index='String(index)+jndex'>
                        <span class="menu_childTitle">
                            •&nbsp;{{jtem.name}}
                        </span>
                        <el-menu-item v-for='(ztem,zndex) in jtem.childList' :key='zndex' :index='String(index)+jndex+zndex' class='menu_childName' @click='chooseItem(item,ztem,jtem)' v-if='ztem.show'>
                            {{ztem.name}}
                        </el-menu-item>
                    </el-menu-item-group>
                </el-submenu>
            </el-menu>
        </div>
        <div class="footer">
            <p>版本号：{{config.vision}}</p>
            <p>客服：{{config.tel}}</p>
        </div>
    </el-aside>
</template>

<script scoped>
import { mapGetters } from "vuex";
import { commonUrl } from "@/api/common";
import { config } from "../config/config";
import { menu } from "@/api/layout/menu";
import pageRouter from "@/utils/pageRouter";

export default {
  name: "asidebar",
  data() {
    return {
      picPrefix: commonUrl.imgPrefix,
      imgPrefix_qN: commonUrl.imgPrefix_qN,
      styleObject: {
        background:
          "url(http://7xrr8i.com2.z0.glb.qiniucdn.com/Mobbig/imagenone/EGusDCHbpbczUFUyqdfCbMGsfeRD3MfZ.jpg) no-repeat center"
      },
      config: config,
      menuList: []
    };
  },
  computed: {
    ...mapGetters("tabs", {
      TABLIST: "tabList",
      TABACTIVE: "tabActive"
    })
  },
  mounted() {
    this.getMenu();
  },
  methods: {
    getMenu() {
      menu()
        .then(res => {
          if (res.Success) {
            this.menuList = res.Data.menuList;
            this.$store.dispatch("tabs/setDefaultMenuList", this.menuList);
            // 菜单路由

            for (let i = 0; i < this.menuList.length; i++) {
              pageRouter(this, this.menuList[i].code).catch((error) => {
                this.$message.error("菜单初始化出错！");
              });
              let items = this.menuList[i].childList;
              for (let j = 0; j < items.length; j++) {
                let item = items[j].childList;
                for (let z = 0; z < item.length; z++) {
                  let visit = this.checkifVisit(item[z].childList)
                  item[z].show = visit
                  pageRouter(
                    this,
                    item[z].code,
                    this.menuList[i].code + "/" + item[z].code + "/index"
                  ).catch(error => {
                      console.log('菜单初始化出错！', error)
                    this.$message.error("菜单初始化出错！");
                  });
                }
              }
            }
          } else {
            this.$message.error(res.Msg);
            this.$router.path({ path: "/login" });
          }
        })
        .catch((error) => {
          console.log(error)
          this.$message.error("菜单生成出错！");
        });
    },

    chooseMenu(item, index) {
      // 选中菜单选项后隐藏子菜单
      document.getElementsByClassName(index)[0].style.display = "none";

      let tab = {
        code: item.code,
        name: item.name,
        item: item.childList,
        root: item.code
      };
      //改变tab
      this.$store.dispatch("tabs/switchTab_single", tab);
    },

    chooseItem(item, ztem, jtem) {
      let tab = {
        code: ztem.code,
        name: ztem.name,
        limit: ztem.childList,
        root: item.code,
        parent: jtem.code
      };
      //改变tab
      this.$store.dispatch("tabs/switchTab_single", tab);
    },

    // 检测是否能访问页面
    checkifVisit(list) {
        if(list.length === 0) {return true}
        for(let i = 0; i < list.length; i++){
            if(list[i].name === '访问'){
                return true
            }
        }
        return false
    }
  }
};
</script>

<style type="text/less" lang="less" scoped>
.aside {
  position: relative;
  width: 160px !important;
  min-height: 100vh;
  background: @main_bgColor;
  color: @menu_color;
}
.logo {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  margin: 0 auto;
  text-align: center;
  height: 83px;
  img {
    width: 38px;
    margin-right: 8px;
    vertical-align: middle;
  }
  span {
    color: #fff;
    font-size: 26px;
    line-height: 83px;
    vertical-align: middle;
  }
}
.menu {
  height: calc(100vh - 153px);
  margin-top: 83px;
  margin-bottom: 70px;
  box-sizing: border-box;
  overflow-y: scroll;
  background: @main_bgColor;
  width: 100%;
  border: none;
  .menu_item {
    width: 140px;
    text-align: left;
    box-sizing: border-box;
    margin: 20px auto 0;
    border-radius: 4px;
    cursor: pointer;
    border: none;
    .icon-wrap {
      display: inline-block;
      width: 26px;
      height: 26px;
      overflow: hidden;
      line-height: 1.5;
      font-size: 14px;
      .icon-item {
        color: #7688a2;
        display: inline-block;
        width: 26px;
        height: 26px;
        overflow: hidden;
        position: relative;
        left: -40px;
        border-right: 40px solid transparent;
        -webkit-filter: drop-shadow(40px 0);
        filter: drop-shadow(40px 0);
        background-size: 100% 100%;
      }
    }
  }
  .menu_active {
    background: @main_color_active;
    color: #fff;
    .icon-wrap {
      .icon-item {
        color: #fff;
      }
    }
  }
}
.menu_childTitle {
  color: @main_color_active;
  font-size: 16px;
}
.menu_childName {
  height: 30px;
  line-height: 30px;
  margin: 10px 0;
}
.footer {
  position: absolute;
  bottom: 0;
  box-sizing: border-box;
  height: 70px;
  padding-top: 20px;
  padding-left: 20px;
  color: #596a84;
  font-size: 10px;
  p {
    margin: 0;
  }
}
/*滚动条*/
::-webkit-scrollbar {
  width: 0px;
}
::-webkit-scrollbar-track,
::-webkit-scrollbar-thumb {
  border-radius: 999px;
  border: 5px solid transparent;
}
::-webkit-scrollbar-track {
  box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.2) inset;
}
::-webkit-scrollbar-thumb {
  min-height: 20px;
  background-clip: content-box;
  box-shadow: 0 0 0 5px rgba(0, 0, 0, 0.2) inset;
}
::-webkit-scrollbar-corner {
  background: transparent;
}
</style>

<style type="text/less" lang="less">
.el-menu--popup {
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.4);
}
.menu .el-submenu__title {
  color: @menu_color;
  border-radius: 4px;
  height: 48px;
  line-height: 48px;
  font-size: 16px;
  display: flex;
  align-items: center;
  .icon-wrap {
    margin-right: 8px;
  }
  &:hover {
    background: @main_color_hover;
    color: #fff;
    .icon-wrap {
      .icon-item {
        color: #fff;
      }
    }
  }
  &:focus {
    background: @main_color_hover;
    color: #fff;
    .icon-wrap {
      .icon-item {
        color: #fff;
      }
    }
  }
}
.menu_active .el-submenu__title,
.menu_active .el-submenu__title i {
  color: #fff;
}
.menu_active .el-submenu__title {
  &:hover {
    background: @main_color_active - 5;
    color: #fff;
  }
}
.el-menu--popup {
  max-width: 700px;
  max-height: 580px;
  overflow: auto;
  padding: 10px 13px 24px;
}
.el-menu-item-group {
  display: inline-block;
  margin: 0 17px;
}
.el-menu--vertical {
  left: 160px !important;
}
.el-menu-item-group {
  vertical-align: top;
}
</style>


// WEBPACK FOOTER //
// src/views/layout/components/Aside.vue